module.exports = __webpack_public_path__ + "static/media/Bublish_Logo_003.00e44d3e.jpg";